export * from './datetime';
export * from './todate';
export * from './truncate';
export * from './capitalize';
export * from './timefromnow';
export * from './weeknumber';
export * from './notificationtime';
export * from './cuit';
export * from './price';
export * from './currency';
export * from './tns';
export * from './priority';
export * from './keys';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/index.ts